define(["backbone"], function (Backbone) {
  "use strict";

  const collaborationFeaturesModel = {};

  collaborationFeaturesModel.convertToObject = function (value) {
    if (!value) {
      return {};
    }
    if (typeof value == "string") {
      return JSON.parse(value);
    }
    return value;
  };

  collaborationFeaturesModel.convertToString = function (value) {
    if (value === undefined || value === null || value === "") {
      return "{}";
    }
    if (typeof value != "string") {
      return JSON.stringify(value);
    }
    return value;
  };

  collaborationFeaturesModel.base = Backbone.Model.extend({
    isNew: function () {
      // Override isNew() since CKEditor always supplies an id
      // Work off of changeTimestamp instead.
      return !this.id || !this.get("changeTimestamp");
    },
  });

  return collaborationFeaturesModel;
});
